var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canshow)?_c('div',[_c('button',{on:{"click":_vm.gotoEsia}},[_vm._v(" Войти через "),_c('img',{attrs:{"src":"img/gosuslugi.svg"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }